import stackElements from './stack-elements';
import createStackElements from './create-stack-elements';

export default function stack(elements) {
    stackElements(createStackElements(elements), "x", "y", "width");
}